import { render, staticRenderFns } from "./ItemsReceivedDeleteModal.vue?vue&type=template&id=34bf1f22&scoped=true&"
import script from "./ItemsReceivedDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ItemsReceivedDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf1f22",
  null
  
)

export default component.exports